export default "__VITE_ASSET__Dd3oaYRt__"